module.exports = __webpack_public_path__ + "img/retrofit-details-5.4df8c9ed.png";